// Specialty-specific rotation types
export const SPECIALTY_ROTATION_TYPES = {
  "General Surgery": [
    "General surgery",
    "Trauma surgery",
    "Surgical ICU",
    "Vascular surgery",
    "Colorectal surgery",
    "Pediatric surgery",
    "Burn surgery",
    "Hernia surgery",
    "Elective surgery",
    "Breast surgery",
    "Endocrine surgery",
    "Surgical oncology",
    "Bariatric surgery",
    "Transplant surgery",
    "Acute care surgery",
    "Surgical consultation",
    "Hepatobiliary surgery",
    "Night float",
  ],
  "Internal Medicine": [
    "General Internal Medicine",
    "Cardiology",
    "Pulmonary/Critical Care",
    "Gastroenterology",
    "Nephrology",
    "Endocrinology",
    "Hematology/Oncology",
    "Infectious Disease",
    "Rheumatology",
    "Geriatrics",
    "Emergency Medicine",
    "ICU",
    "Outpatient Clinic",
    "Consultation Service",
    "Research",
    "Administrative",
  ],
  "Family Medicine": [
    "Family Medicine Clinic",
    "Obstetrics",
    "Pediatrics",
    "Emergency Medicine",
    "Internal Medicine",
    "Surgery",
    "Psychiatry",
    "Geriatrics",
    "Sports Medicine",
    "Rural Medicine",
    "Community Health",
    "Research",
    "Administrative",
  ],
  "Pediatrics": [
    "General Pediatrics",
    "Neonatology",
    "Pediatric Emergency Medicine",
    "Pediatric ICU",
    "Pediatric Cardiology",
    "Pediatric Oncology",
    "Pediatric Surgery",
    "Adolescent Medicine",
    "Developmental Pediatrics",
    "Pediatric Neurology",
    "Pediatric Gastroenterology",
    "Pediatric Endocrinology",
    "Pediatric Infectious Disease",
    "Outpatient Clinic",
    "Research",
  ],
  "Obstetrics and Gynecology": [
    "General Obstetrics",
    "Gynecologic Surgery",
    "Maternal-Fetal Medicine",
    "Reproductive Endocrinology",
    "Gynecologic Oncology",
    "Urogynecology",
    "Family Planning",
    "Emergency Obstetrics",
    "Gynecologic Pathology",
    "Research",
    "Administrative",
  ],
  "Psychiatry": [
    "General Psychiatry",
    "Child and Adolescent Psychiatry",
    "Addiction Psychiatry",
    "Forensic Psychiatry",
    "Geriatric Psychiatry",
    "Consultation-Liaison Psychiatry",
    "Emergency Psychiatry",
    "Community Psychiatry",
    "Research",
    "Administrative",
  ],
  "Emergency Medicine": [
    "Emergency Department",
    "Trauma",
    "Pediatric Emergency",
    "Toxicology",
    "Emergency Medical Services",
    "Critical Care",
    "Ultrasound",
    "Research",
    "Administrative",
  ],
  "Anesthesiology": [
    "General Anesthesia",
    "Cardiac Anesthesia",
    "Pediatric Anesthesia",
    "Obstetric Anesthesia",
    "Pain Management",
    "Critical Care",
    "Regional Anesthesia",
    "Research",
    "Administrative",
  ],
  "Radiology": [
    "General Radiology",
    "Interventional Radiology",
    "Neuroradiology",
    "Musculoskeletal Radiology",
    "Pediatric Radiology",
    "Nuclear Medicine",
    "Ultrasound",
    "Research",
    "Administrative",
  ],
  "Pathology": [
    "Anatomic Pathology",
    "Clinical Pathology",
    "Cytopathology",
    "Hematopathology",
    "Molecular Pathology",
    "Forensic Pathology",
    "Research",
    "Administrative",
  ],
  "Dermatology": [
    "General Dermatology",
    "Surgical Dermatology",
    "Pediatric Dermatology",
    "Dermatopathology",
    "Cosmetic Dermatology",
    "Research",
    "Administrative",
  ],
  "Neurology": [
    "General Neurology",
    "Stroke",
    "Epilepsy",
    "Movement Disorders",
    "Neuromuscular",
    "Neurocritical Care",
    "Pediatric Neurology",
    "Research",
    "Administrative",
  ],
  "Orthopedics": [
    "General Orthopedics",
    "Trauma",
    "Sports Medicine",
    "Joint Replacement",
    "Spine Surgery",
    "Hand Surgery",
    "Pediatric Orthopedics",
    "Foot and Ankle",
    "Research",
    "Administrative",
  ],
  "Cardiology": [
    "General Cardiology",
    "Interventional Cardiology",
    "Electrophysiology",
    "Heart Failure",
    "Cardiac Imaging",
    "Preventive Cardiology",
    "Research",
    "Administrative",
  ],
  /*"Oncology": [
    "Medical Oncology",
    "Radiation Oncology",
    "Surgical Oncology",
    "Hematologic Oncology",
    "Pediatric Oncology",
    "Research",
    "Administrative",
  ],*/
  "Urology": [
    "General Urology",
    "Urologic Oncology",
    "Pediatric Urology",
    "Female Urology",
    "Male Reproductive Medicine",
    "Endourology",
    "Research",
    "Administrative",
  ],
  "Ophthalmology": [
    "General Ophthalmology",
    "Retina",
    "Glaucoma",
    "Cornea",
    "Pediatric Ophthalmology",
    "Oculoplastics",
    "Neuro-ophthalmology",
    "Research",
    "Administrative",
  ],
  "HENT Surgery": [
    "General Otolaryngology",
    "Head and Neck Surgery",
    "Pediatric Otolaryngology",
    "Otology/Neurotology",
    "Rhinology",
    "Laryngology",
    "Research",
    "Administrative",
  ],
  "Plastic Surgery": [
    "General Plastic Surgery",
    "Hand Surgery",
    "Microsurgery",
    "Craniofacial Surgery",
    "Burn Surgery",
    "Aesthetic Surgery",
    "Research",
    "Administrative",
  ],
  "Vascular Surgery": [
    "General Vascular Surgery",
    "Endovascular Surgery",
    "Vascular Medicine",
    "Research",
    "Administrative",
  ],
  "Thoracic Surgery": [
    "General Thoracic Surgery",
    "Cardiothoracic Surgery",
    "Lung Transplantation",
    "Research",
    "Administrative",
  ],
  "Neurosurgery": [
    "General Neurosurgery",
    "Spine Surgery",
    "Pediatric Neurosurgery",
    "Neuro-oncology",
    "Functional Neurosurgery",
    "Research",
    "Administrative",
  ],
  /*"Physical Medicine and Rehabilitation": [
    "General PM&R",
    "Spine Medicine",
    "Sports Medicine",
    "Pediatric Rehabilitation",
    "Brain Injury",
    "Spinal Cord Injury",
    "Research",
    "Administrative",
  ],
  "Preventive Medicine": [
    "General Preventive Medicine",
    "Occupational Medicine",
    "Public Health",
    "Research",
    "Administrative",
  ],
  "Medical Genetics": [
    "Clinical Genetics",
    "Biochemical Genetics",
    "Cytogenetics",
    "Molecular Genetics",
    "Research",
    "Administrative",
  ],
  "Nuclear Medicine": [
    "General Nuclear Medicine",
    "Nuclear Cardiology",
    "Nuclear Oncology",
    "Research",
    "Administrative",
  ],
  "Pain Medicine": [
    "General Pain Medicine",
    "Interventional Pain",
    "Chronic Pain",
    "Research",
    "Administrative",
  ],
  "Sleep Medicine": [
    "General Sleep Medicine",
    "Sleep Disorders",
    "Research",
    "Administrative",
  ],
  "Sports Medicine": [
    "General Sports Medicine",
    "Primary Care Sports Medicine",
    "Orthopedic Sports Medicine",
    "Research",
    "Administrative",
  ],
  "Hospice and Palliative Medicine": [
    "General Palliative Medicine",
    "Hospice Care",
    "Research",
    "Administrative",
  ],*/
};

// Default rotation types (fallback)
export const DEFAULT_ROTATION_TYPES = [
  'General surgery',
  'Trauma surgery',
  'Surgical ICU',
  'Vascular surgery',
  'Colorectal surgery',
  'Pediatric surgery',
  'Burn surgery',
  'Hernia surgery',
  'Elective surgery',
  'Breast surgery',
  'Endocrine surgery',
  'Surgical oncology',
  'Bariatric surgery',
  'Transplant surgery',
  'Acute care surgery',
  'Surgical consultation',
  'Hepatobiliary surgery',
  'Night float',
];

// Comprehensive rotation abbreviations
export const ROTATION_ABBREVIATIONS = {
  // General Surgery
  "General surgery": "Gen Surg",
  "Pediatric surgery": "Peds Surg",
  "Colorectal surgery": "ColoRectal",
  "Hepato-biliary surgery": "Hepato/Bili",
  "Oncologic surgery": "Surg Onc",
  "Burn surgery": "Burn",
  "Hernia surgery": "Hernia",
  "Elective surgery": "Elective",
  "Acute care surgery": "ACS",
  "Trauma surgery": "Trauma",
  "Bariatric surgery": "Bariatric",
  "Surgical ICU": "SICU",
  "HENT surgery": "HENT",
  "Renal surgery": "Renal",
  "Transplant surgery": "Transplant",
  "Vascular surgery": "Vascular",
  "Plastic surgery": "Plastic",
  "Night float": "Nights",
  "Surgical consultation": "Consults",
  "Breast surgery": "Breast",

  // Internal Medicine
  "General Internal Medicine": "Gen IM",
  "Cardiology": "Cardio",
  "Pulmonary/Critical Care": "Pulm/CC",
  "Gastroenterology": "GI",
  "Nephrology": "Nephro",
  "Endocrinology": "Endo",
  "Neurology": "Neuro",
  "Hematology/Oncology": "Heme/Onc",
  "Infectious Disease": "ID",
  "Rheumatology": "Rheum",
  "Geriatrics": "Geriatrics",
  "Emergency Medicine": "EM",
  "ICU": "ICU",
  "Outpatient Clinic": "Clinic",
  "Consultation Service": "Consult",
  "Research": "Research",
  "Administrative": "Admin",

  // Family Medicine
  "Family Medicine Clinic": "FM Clinic",
  "FM Obstetrics": "OB",
  "FM Pediatrics": "Peds",
  "FM Emergency Medicine": "EM",
  "FM Internal Medicine": "IM",
  "FM Surgery": "Surgery",
  "FM Psychiatry": "Psych",
  "FM Geriatrics": "Geriatrics",
  "FM Sports Medicine": "Sports Med",
  "FM Rural Medicine": "Rural Med",
  "FM Community Health": "Comm Health",
  "FM Research": "Research",
  "FM Administrative": "Admin",

  // Pediatrics
  "General Pediatrics": "Gen Peds",
  "Neonatology": "Neonatal",
  "Pediatric Emergency Medicine": "Peds EM",
  "Pediatric ICU": "PICU",
  "Pediatric Cardiology": "Peds Cardio",
  "Pediatric Oncology": "Peds Onc",
  "Pediatric Surgery": "Peds Surg",
  "Adolescent Medicine": "Adolescent",
  "Developmental Pediatrics": "Dev Peds",
  "Pediatric Neurology": "Peds Neuro",
  "Pediatric Gastroenterology": "Peds GI",
  "Pediatric Endocrinology": "Peds Endo",
  "Pediatric Infectious Disease": "Peds ID",
  "Peds Outpatient Clinic": "Clinic",
  "Peds Research": "Research",

  // Obstetrics and Gynecology
  "General Obstetrics": "Gen OB",
  "Gynecologic Surgery": "Gyn Surg",
  "Maternal-Fetal Medicine": "MFM",
  "Reproductive Endocrinology": "Repro Endo",
  "Gynecologic Oncology": "Gyn Onc",
  "Urogynecology": "UroGyn",
  "Family Planning": "Fam Planning",
  "Emergency Obstetrics": "Emerg OB",
  "Gynecologic Pathology": "Gyn Path",
  "OBGYN Research": "Research",
  "OBGYN Administrative": "Admin",

  // Psychiatry
  "General Psychiatry": "Gen Psych",
  "Child and Adolescent Psychiatry": "Child Psych",
  "Addiction Psychiatry": "Addiction",
  "Forensic Psychiatry": "Forensic",
  "Geriatric Psychiatry": "Geriatric Psych",
  "Consultation-Liaison Psychiatry": "C/L Psych",
  "Emergency Psychiatry": "Emerg Psych",
  "Community Psychiatry": "Comm Psych",
  "Psych Research": "Research",
  "Psych Administrative": "Admin",

  // Emergency Medicine
  "Emergency Department": "ED",
  "EM Trauma": "Trauma",
  "Pediatric Emergency": "Peds ED",
  "Toxicology": "Tox",
  "Emergency Medical Services": "EMS",
  "EM Critical Care": "CC",
  "EM Ultrasound": "US",
  "EM Research": "Research",
  "EM Administrative": "Admin",

  // Anesthesiology
  "General Anesthesia": "Gen Anes",
  "Cardiac Anesthesia": "Cardiac Anes",
  "Pediatric Anesthesia": "Peds Anes",
  "Obstetric Anesthesia": "OB Anes",
  "Pain Management": "Pain Mgmt",
  "Anes Critical Care": "CC",
  "Regional Anesthesia": "Regional",
  "Anes Research": "Research",
  "Anes Administrative": "Admin",

  // Radiology
  "General Radiology": "Gen Rad",
  "Interventional Radiology": "IR",
  "Neuroradiology": "Neuro Rad",
  "Musculoskeletal Radiology": "MSK Rad",
  "Pediatric Radiology": "Peds Rad",
  "Nuclear Medicine": "Nuc Med",
  "Rad Ultrasound": "US",
  "Rad Research": "Research",
  "Rad Administrative": "Admin",

  // Pathology
  "Anatomic Pathology": "Anatomic Path",
  "Clinical Pathology": "Clinical Path",
  "Cytopathology": "Cyto Path",
  "Hematopathology": "Heme Path",
  "Molecular Pathology": "Mol Path",
  "Forensic Pathology": "Forensic Path",
  "Path Research": "Research",
  "Path Administrative": "Admin",

  // Dermatology
  "General Dermatology": "Gen Derm",
  "Surgical Dermatology": "Surg Derm",
  "Pediatric Dermatology": "Peds Derm",
  "Dermatopathology": "Derm Path",
  "Cosmetic Dermatology": "Cosmetic Derm",
  "Derm Research": "Research",
  "Derm Administrative": "Admin",

  // Neurology
  "General Neurology": "Gen Neuro",
  "Stroke": "Stroke",
  "Epilepsy": "Epilepsy",
  "Movement Disorders": "Movement",
  "Neuromuscular": "NeuroMusc",
  "Neurocritical Care": "Neuro CC",
  "Pediatric Neurology": "Peds Neuro",
  "Neuro Research": "Research",
  "Neuro Administrative": "Admin",

  // Orthopedic Surgery
  "General Orthopedics": "Gen Ortho",
  "Ortho Trauma": "Trauma",
  "Ortho Sports Medicine": "Sports Med",
  "Joint Replacement": "Joint Repl",
  "Spine Surgery": "Spine",
  "Hand Surgery": "Hand",
  "Pediatric Orthopedics": "Peds Ortho",
  "Foot and Ankle": "Foot/Ankle",
  "Ortho Research": "Research",
  "Ortho Administrative": "Admin",

  // Cardiology
  "General Cardiology": "Gen Cardio",
  "Interventional Cardiology": "Interv Cardio",
  "Electrophysiology": "EP",
  "Heart Failure": "HF",
  "Cardiac Imaging": "Cardiac Img",
  "Preventive Cardiology": "Prev Cardio",
  "Cardio Research": "Research",
  "Cardio Administrative": "Admin",

  // Oncology
  "Medical Oncology": "Med Onc",
  "Radiation Oncology": "Rad Onc",
  "Surgical Oncology": "Surg Onc",
  "Hematologic Oncology": "Heme Onc",
  "Pediatric Oncology": "Peds Onc",
  "Onc Research": "Research",
  "Onc Administrative": "Admin",

  // Urology
  "General Urology": "Gen Uro",
  "Urologic Oncology": "Uro Onc",
  "Pediatric Urology": "Peds Uro",
  "Female Urology": "Female Uro",
  "Male Reproductive Medicine": "Male Repro",
  "Endourology": "Endo Uro",
  "Uro Research": "Research",
  "Uro Administrative": "Admin",

  // Ophthalmology
  "General Ophthalmology": "Gen Ophth",
  "Retina": "Retina",
  "Glaucoma": "Glaucoma",
  "Cornea": "Cornea",
  "Pediatric Ophthalmology": "Peds Ophth",
  "Oculoplastics": "Oculoplastics",
  "Neuro-ophthalmology": "Neuro Ophth",
  "Ophth Research": "Research",
  "Ophth Administrative": "Admin",

  // Otolaryngology
  "General Otolaryngology": "Gen ENT",
  "Head and Neck Surgery": "H&N",
  "Pediatric Otolaryngology": "Peds ENT",
  "Otology/Neurotology": "Otology",
  "Rhinology": "Rhinology",
  "Laryngology": "Laryngology",
  "ENT Research": "Research",
  "ENT Administrative": "Admin",

  // Plastic Surgery
  "General Plastic Surgery": "Gen Plastic",
  "Plastic Hand Surgery": "Hand",
  "Microsurgery": "Micro",
  "Craniofacial Surgery": "Craniofacial",
  "Plastic Burn Surgery": "Burn",
  "Aesthetic Surgery": "Aesthetic",
  "Plastic Research": "Research",
  "Plastic Administrative": "Admin",

  // Vascular Surgery
  "General Vascular Surgery": "Gen Vascular",
  "Endovascular Surgery": "Endovascular",
  "Vascular Medicine": "Vascular Med",
  "Vascular Research": "Research",
  "Vascular Administrative": "Admin",

  // Thoracic Surgery
  "General Thoracic Surgery": "Gen Thoracic",
  "Cardiothoracic Surgery": "Cardiothoracic",
  "Lung Transplantation": "Lung Transplant",
  "Thoracic Research": "Research",
  "Thoracic Administrative": "Admin",

  // Neurosurgery
  "General Neurosurgery": "Gen Neuro",
  "Neuro Spine Surgery": "Spine",
  "Pediatric Neurosurgery": "Peds Neuro",
  "Neuro-oncology": "Neuro Onc",
  "Functional Neurosurgery": "Functional",
  "Neurosurg Research": "Research",
  "Neurosurg Administrative": "Admin",

  // Physical Medicine and Rehabilitation
  "General PM&R": "Gen PM&R",
  "PMR Spine Medicine": "Spine Med",
  "PMR Sports Medicine": "Sports Med",
  "Pediatric Rehabilitation": "Peds Rehab",
  "Brain Injury": "Brain Injury",
  "Spinal Cord Injury": "SCI",
  "PMR Research": "Research",
  "PMR Administrative": "Admin",

  // Preventive Medicine
  "General Preventive Medicine": "Gen Prev Med",
  "Occupational Medicine": "Occupational",
  "Public Health": "Public Health",
  "Prev Med Research": "Research",
  "Prev Med Administrative": "Admin",

  // Medical Genetics
  "Clinical Genetics": "Clinical Genetics",
  "Biochemical Genetics": "Biochem Genetics",
  "Cytogenetics": "Cytogenetics",
  "Molecular Genetics": "Mol Genetics",
  "Genetics Research": "Research",
  "Genetics Administrative": "Admin",

  // Nuclear Medicine
  "General Nuclear Medicine": "Gen Nuc Med",
  "Nuclear Cardiology": "Nuc Cardio",
  "Nuclear Oncology": "Nuc Onc",
  "Nuc Med Research": "Research",
  "Nuc Med Administrative": "Admin",

  // Pain Medicine
  "General Pain Medicine": "Gen Pain",
  "Interventional Pain": "Interv Pain",
  "Chronic Pain": "Chronic Pain",
  "Pain Research": "Research",
  "Pain Administrative": "Admin",

  // Sleep Medicine
  "General Sleep Medicine": "Gen Sleep",
  "Sleep Disorders": "Sleep Disorders",
  "Sleep Research": "Research",
  "Sleep Administrative": "Admin",

  // Sports Medicine
  "General Sports Medicine": "Gen Sports",
  "Primary Care Sports Medicine": "PC Sports",
  "Orthopedic Sports Medicine": "Ortho Sports",
  "Sports Med Research": "Research",
  "Sports Med Administrative": "Admin",

  // Hospice and Palliative Medicine
  "General Palliative Medicine": "Gen Palliative",
  "Hospice Care": "Hospice",
  "Palliative Research": "Research",
  "Palliative Administrative": "Admin",
};

// Specialty-specific rotation colors
export const SPECIALTY_ROTATION_COLORS = {
  "General Surgery": {
    'General surgery': '#3B82F6',
    'Trauma surgery': '#F97316',
    'Surgical ICU': '#F59E0B',
    'Vascular surgery': '#01D8AE',
    'Colorectal surgery': '#8B5CF6',
    'Pediatric surgery': '#06B6D4',
    'Burn surgery': '#EA580C',
    'Hernia surgery': '#FBBF24',
    'Elective surgery': '#84CC16',
    'Breast surgery': '#F472B6',
    'Endocrine surgery': '#FCD34D',
    'Surgical oncology': '#FB7185',
    'Bariatric surgery': '#F6C000',
    'Transplant surgery': '#60A5FA',
    'Acute care surgery': '#DC2626',
    'Surgical consultation': '#F87171',
    'Hepatobiliary surgery': '#F97316',
    'Night float': '#687179'
  },
  "Internal Medicine": {
    'General Internal Medicine': '#3B82F6',
    'Cardiology': '#EF4444',
    'Pulmonary/Critical Care': '#06B6D4',
    'Gastroenterology': '#10B981',
    'Nephrology': '#8B5CF6',
    'Endocrinology': '#F59E0B',
    'Hematology/Oncology': '#EC4899',
    'Infectious Disease': '#84CC16',
    'Rheumatology': '#DC2626',
    'Geriatrics': '#7C3AED',
    'Emergency Medicine': '#059669',
    'ICU': '#EA580C',
    'Outpatient Clinic': '#6366F1',
    'Consultation Service': '#0891B2',
    'Research': '#BE185D',
    'Administrative': '#16A34A'
  },
  "Family Medicine": {
    'Family Medicine Clinic': '#3B82F6',
    'Obstetrics': '#EC4899',
    'Pediatrics': '#10B981',
    'Emergency Medicine': '#EF4444',
    'Internal Medicine': '#8B5CF6',
    'Surgery': '#F59E0B',
    'Psychiatry': '#06B6D4',
    'Geriatrics': '#84CC16',
    'Sports Medicine': '#DC2626',
    'Rural Medicine': '#7C3AED',
    'Community Health': '#059669',
    'Research': '#EA580C',
    'Administrative': '#6366F1'
  },
  "Pediatrics": {
    'General Pediatrics': '#3B82F6',
    'Neonatology': '#10B981',
    'Pediatric Emergency Medicine': '#EF4444',
    'Pediatric ICU': '#8B5CF6',
    'Pediatric Cardiology': '#F59E0B',
    'Pediatric Oncology': '#EC4899',
    'Pediatric Surgery': '#06B6D4',
    'Adolescent Medicine': '#84CC16',
    'Developmental Pediatrics': '#DC2626',
    'Pediatric Neurology': '#7C3AED',
    'Pediatric Gastroenterology': '#059669',
    'Pediatric Endocrinology': '#EA580C',
    'Pediatric Infectious Disease': '#6366F1',
    'Outpatient Clinic': '#0891B2',
    'Research': '#BE185D'
  },
  "Obstetrics and Gynecology": {
    'General Obstetrics': '#3B82F6',
    'Gynecologic Surgery': '#EF4444',
    'Maternal-Fetal Medicine': '#10B981',
    'Reproductive Endocrinology': '#8B5CF6',
    'Gynecologic Oncology': '#F59E0B',
    'Urogynecology': '#EC4899',
    'Family Planning': '#06B6D4',
    'Emergency Obstetrics': '#84CC16',
    'Gynecologic Pathology': '#DC2626',
    'Research': '#7C3AED',
    'Administrative': '#059669'
  },
  "Psychiatry": {
    'General Psychiatry': '#3B82F6',
    'Child and Adolescent Psychiatry': '#10B981',
    'Addiction Psychiatry': '#EF4444',
    'Forensic Psychiatry': '#8B5CF6',
    'Geriatric Psychiatry': '#F59E0B',
    'Consultation-Liaison Psychiatry': '#EC4899',
    'Emergency Psychiatry': '#06B6D4',
    'Community Psychiatry': '#84CC16',
    'Research': '#DC2626',
    'Administrative': '#7C3AED'
  },
  "Emergency Medicine": {
    'Emergency Department': '#3B82F6',
    'Trauma': '#EF4444',
    'Pediatric Emergency': '#10B981',
    'Toxicology': '#8B5CF6',
    'Emergency Medical Services': '#F59E0B',
    'Critical Care': '#EC4899',
    'Ultrasound': '#06B6D4',
    'Research': '#84CC16',
    'Administrative': '#DC2626'
  },
  "Anesthesiology": {
    'General Anesthesia': '#3B82F6',
    'Cardiac Anesthesia': '#EF4444',
    'Pediatric Anesthesia': '#10B981',
    'Obstetric Anesthesia': '#8B5CF6',
    'Pain Management': '#F59E0B',
    'Critical Care': '#EC4899',
    'Regional Anesthesia': '#06B6D4',
    'Research': '#84CC16',
    'Administrative': '#DC2626'
  },
  "Radiology": {
    'General Radiology': '#3B82F6',
    'Interventional Radiology': '#EF4444',
    'Neuroradiology': '#10B981',
    'Musculoskeletal Radiology': '#8B5CF6',
    'Pediatric Radiology': '#F59E0B',
    'Nuclear Medicine': '#EC4899',
    'Ultrasound': '#06B6D4',
    'Research': '#84CC16',
    'Administrative': '#DC2626'
  },
  "Pathology": {
    'Anatomic Pathology': '#3B82F6',
    'Clinical Pathology': '#EF4444',
    'Cytopathology': '#10B981',
    'Hematopathology': '#8B5CF6',
    'Molecular Pathology': '#F59E0B',
    'Forensic Pathology': '#EC4899',
    'Research': '#06B6D4',
    'Administrative': '#84CC16'
  },
  "Dermatology": {
    'General Dermatology': '#3B82F6',
    'Surgical Dermatology': '#EF4444',
    'Pediatric Dermatology': '#10B981',
    'Dermatopathology': '#8B5CF6',
    'Cosmetic Dermatology': '#F59E0B',
    'Research': '#EC4899',
    'Administrative': '#06B6D4'
  },
  "Neurology": {
    'General Neurology': '#3B82F6',
    'Stroke': '#EF4444',
    'Epilepsy': '#10B981',
    'Movement Disorders': '#8B5CF6',
    'Neuromuscular': '#F59E0B',
    'Neurocritical Care': '#EC4899',
    'Pediatric Neurology': '#06B6D4',
    'Research': '#84CC16',
    'Administrative': '#DC2626'
  },
  "Orthopedics": {
    'General Orthopedics': '#3B82F6',
    'Trauma': '#EF4444',
    'Sports Medicine': '#10B981',
    'Joint Replacement': '#8B5CF6',
    'Spine Surgery': '#F59E0B',
    'Hand Surgery': '#EC4899',
    'Pediatric Orthopedics': '#06B6D4',
    'Foot and Ankle': '#84CC16',
    'Research': '#DC2626',
    'Administrative': '#7C3AED'
  },
  "Cardiology": {
    'General Cardiology': '#3B82F6',
    'Interventional Cardiology': '#EF4444',
    'Electrophysiology': '#10B981',
    'Heart Failure': '#8B5CF6',
    'Cardiac Imaging': '#F59E0B',
    'Preventive Cardiology': '#EC4899',
    'Research': '#06B6D4',
    'Administrative': '#84CC16'
  },
  "Oncology": {
    'Medical Oncology': '#3B82F6',
    'Radiation Oncology': '#EF4444',
    'Surgical Oncology': '#10B981',
    'Hematologic Oncology': '#8B5CF6',
    'Pediatric Oncology': '#F59E0B',
    'Research': '#EC4899',
    'Administrative': '#06B6D4'
  },
  "Urology": {
    'General Urology': '#3B82F6',
    'Urologic Oncology': '#EF4444',
    'Pediatric Urology': '#10B981',
    'Female Urology': '#8B5CF6',
    'Male Reproductive Medicine': '#F59E0B',
    'Endourology': '#EC4899',
    'Research': '#06B6D4',
    'Administrative': '#84CC16'
  },
  "Ophthalmology": {
    'General Ophthalmology': '#3B82F6',
    'Retina': '#EF4444',
    'Glaucoma': '#10B981',
    'Cornea': '#8B5CF6',
    'Pediatric Ophthalmology': '#F59E0B',
    'Oculoplastics': '#EC4899',
    'Neuro-ophthalmology': '#06B6D4',
    'Research': '#84CC16',
    'Administrative': '#DC2626'
  },
  "Otolaryngology": {
    'General Otolaryngology': '#3B82F6',
    'Head and Neck Surgery': '#EF4444',
    'Pediatric Otolaryngology': '#10B981',
    'Otology/Neurotology': '#8B5CF6',
    'Rhinology': '#F59E0B',
    'Laryngology': '#EC4899',
    'Research': '#06B6D4',
    'Administrative': '#84CC16'
  },
  "Plastic Surgery": {
    'General Plastic Surgery': '#3B82F6',
    'Hand Surgery': '#EF4444',
    'Microsurgery': '#10B981',
    'Craniofacial Surgery': '#8B5CF6',
    'Burn Surgery': '#F59E0B',
    'Aesthetic Surgery': '#EC4899',
    'Research': '#06B6D4',
    'Administrative': '#84CC16'
  },
  "Vascular Surgery": {
    'General Vascular Surgery': '#3B82F6',
    'Endovascular Surgery': '#EF4444',
    'Vascular Medicine': '#10B981',
    'Research': '#8B5CF6',
    'Administrative': '#F59E0B'
  },
  "Thoracic Surgery": {
    'General Thoracic Surgery': '#3B82F6',
    'Cardiothoracic Surgery': '#EF4444',
    'Lung Transplantation': '#10B981',
    'Research': '#8B5CF6',
    'Administrative': '#F59E0B'
  },
  "Neurosurgery": {
    'General Neurosurgery': '#3B82F6',
    'Spine Surgery': '#EF4444',
    'Pediatric Neurosurgery': '#10B981',
    'Neuro-oncology': '#8B5CF6',
    'Functional Neurosurgery': '#F59E0B',
    'Research': '#EC4899',
    'Administrative': '#06B6D4'
  },
  "Physical Medicine and Rehabilitation": {
    'General PM&R': '#3B82F6',
    'Spine Medicine': '#EF4444',
    'Sports Medicine': '#10B981',
    'Pediatric Rehabilitation': '#8B5CF6',
    'Brain Injury': '#F59E0B',
    'Spinal Cord Injury': '#EC4899',
    'Research': '#06B6D4',
    'Administrative': '#84CC16'
  },
  "Preventive Medicine": {
    'General Preventive Medicine': '#3B82F6',
    'Occupational Medicine': '#EF4444',
    'Public Health': '#10B981',
    'Research': '#8B5CF6',
    'Administrative': '#F59E0B'
  },
  "Medical Genetics": {
    'Clinical Genetics': '#3B82F6',
    'Biochemical Genetics': '#EF4444',
    'Cytogenetics': '#10B981',
    'Molecular Genetics': '#8B5CF6',
    'Research': '#F59E0B',
    'Administrative': '#EC4899'
  },
  "Nuclear Medicine": {
    'General Nuclear Medicine': '#3B82F6',
    'Nuclear Cardiology': '#EF4444',
    'Nuclear Oncology': '#10B981',
    'Research': '#8B5CF6',
    'Administrative': '#F59E0B'
  },
  "Pain Medicine": {
    'General Pain Medicine': '#3B82F6',
    'Interventional Pain': '#EF4444',
    'Chronic Pain': '#10B981',
    'Research': '#8B5CF6',
    'Administrative': '#F59E0B'
  },
  "Sleep Medicine": {
    'General Sleep Medicine': '#3B82F6',
    'Sleep Disorders': '#EF4444',
    'Research': '#10B981',
    'Administrative': '#8B5CF6'
  },
  "Sports Medicine": {
    'General Sports Medicine': '#3B82F6',
    'Primary Care Sports Medicine': '#EF4444',
    'Orthopedic Sports Medicine': '#10B981',
    'Research': '#8B5CF6',
    'Administrative': '#F59E0B'
  },
  "Hospice and Palliative Medicine": {
    'General Palliative Medicine': '#3B82F6',
    'Hospice Care': '#EF4444',
    'Research': '#10B981',
    'Administrative': '#8B5CF6'
  }
};

// Default rotation colors (fallback)
export const DEFAULT_ROTATION_COLORS = {
  'General surgery': '#3B82F6',
  'Pediatric surgery': '#10B981',
  'Colorectal surgery': '#8B5CF6',
  'Hepato-biliary surgery': '#F59E0B',
  'Oncologic surgery': '#EF4444',
  'Burn surgery': '#EC4899',
  'Hernia surgery': '#06B6D4',
  'Elective surgery': '#84CC16',
  'Acute care surgery': '#DC2626',
  'Trauma surgery': '#7C3AED',
  'Bariatric surgery': '#059669',
  'Surgical ICU': '#EA580C',
  'HENT surgery': '#6366F1',
  'Renal surgery': '#0891B2',
  'Transplant surgery': '#BE185D',
  'Vascular surgery': '#16A34A',
  'Plastic surgery': '#9333EA'
};

// Helper function to get rotation types and colors based on specialty
export const getRotationTypesForSpecialty = (specialty) => {
  if (!specialty) return { types: DEFAULT_ROTATION_TYPES, colors: DEFAULT_ROTATION_COLORS };
  
  const types = SPECIALTY_ROTATION_TYPES[specialty] || DEFAULT_ROTATION_TYPES;
  const colors = SPECIALTY_ROTATION_COLORS[specialty] || DEFAULT_ROTATION_COLORS;
  
  return { types, colors };
};

// Smart abbreviation function
export const getRotationLabel = (rotation) => {
  if (!rotation) return '-';
  
  // Check predefined abbreviations first
  if (ROTATION_ABBREVIATIONS[rotation]) {
    return ROTATION_ABBREVIATIONS[rotation];
  }
  
  // For custom rotations, use smart abbreviation
  const words = rotation.split(' ');
  if (words.length === 1) {
    return rotation.length > 12 ? rotation.substring(0, 10) + '...' : rotation;
  } else {
    // Take first 2-3 letters of each word for better readability
    return words.map(word => word.substring(0, 3)).join(' ').toUpperCase();
  }
}; 